import currency from 'currency.js';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../../commons/Header';
import { ReactComponent as IconBuilding } from '../../../images/icn_buildings.svg';
import { Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import {
  BtnOutlineGreen,
  ContFilterYear,
  ContFlexRight,
  ContPaginationPage,
} from '../../../styled-components';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../../lib/helpers/generateMonthOptions';
import SearchInput from '../../../commons/SearchInput';
import InsurancesTable from './InsurancesTable';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';
import TotalTr from './TotalTr';
import Footer from '../../../commons/Footer';
import ModalConfirm from '../../../commons/ModalConfirm';
import ModalInvoiceDetailPanoramica from '../../../commons/ModalInvoiceDetailPanoramica';

const InsurancesPresentational = ({
  data,
  profile,
  query,
  total,
  onFilter,
  selectedInsurances,
  onInvoice,
  selectedAll,
  onSelectAll,
  onSelectChange,
  onStatusChanged,
  searchAdministrators,
  searchEstateAgents,
  searchCommercials,
  fetchAdminCondos,
  fetchAdminCustomers,
  condos,
  customersExtra,
  onInsuranceUpdate,
}) => {
  const [t] = useTranslation('INSURANCES');
  const { offset, limit, customerType, active } = query;

  const [modalState, setModalState] = useState({
    isOpen: false,
    selectedId: null,
  });
  const [totalInsurancesValue, setTotalInsurancesValue] = useState(0);

  const onOpenModal = () => {
    const itemsForTotalValue = selectedInsurances.map((_id) => {
      return (
        data.find((insurance) => insurance._id === _id).shareToInvoice || 0
      );
    });
    let total = 0;
    itemsForTotalValue.forEach((value) => {
      total += value;
    });
    setTotalInsurancesValue(
      currency(total, { symbol: '€', precision: 2 }).format()
    );
  };

  const getTotals = (data) => {
    const shareToInvoiceTotals = data.reduce(
      (prev, cur) => prev + (cur.shareToInvoice || 0),
      0
    );
    const panoramicaShareTotals = data.reduce(
      (prev, cur) => prev + (cur.panoramicaShare || 0),
      0
    );
    const adminShareTotals = data.reduce(
      (prev, cur) => prev + (cur.adminShare || 0),
      0
    );
    const netTotals = data.reduce((prev, cur) => prev + cur.net, 0);
    const grossTotals = data.reduce((prev, cur) => prev + cur.gross, 0);

    return {
      shareToInvoiceTotals,
      panoramicaShareTotals,
      adminShareTotals,
      netTotals,
      grossTotals,
    };
  };

  return (
    <section>
      <Header
        title={t('PAGES:INSURANCES')}
        icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
      />

      <Row className="align-items-center">
        <Col className="">
          <ContFlexRight>
            Assicurazioni:&nbsp;<strong>{total}</strong>&nbsp;
          </ContFlexRight>
        </Col>
      </Row>

      <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
        <Col sm="12" md="6" lg="3" className="select-wrapper">
          <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
            <Row>
              <Col xs="6">
                <Label>{t('START_DATE')}</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="selectinsuranceStartYear"
                    name="insuranceStartYear"
                    value={query && query.insuranceStartYear}
                    onChange={({ target: { value: insuranceStartYear } }) => {
                      onFilter({ insuranceStartYear });
                    }}
                  >
                    {generateYearOptions(true)}
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>
        </Col>

        <Col sm="12" md="6" lg="3" className="select-wrapper">
          <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
            <Row>
              <Col xs="6">
                <Label>{t('TITLE_FILTER_SIGNIN_MONTH')}</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="insuranceStartMonth"
                    name="insuranceStartMonth"
                    disabled={!query.insuranceStartYear}
                    value={query && query.insuranceStartMonth}
                    onChange={({ target: { value: insuranceStartMonth } }) =>
                      onFilter({ insuranceStartMonth })
                    }
                  >
                    {generateMonthOptions()}
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>
        </Col>

        <Col sm="12" md="6" lg="3" className="select-wrapper">
          <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
            <Row>
              <Col xs="6">
                <Label>{t('END_DATE')}</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="selectinsuranceEndYear"
                    name="insuranceEndYear"
                    value={query && query.insuranceEndYear}
                    onChange={({ target: { value: insuranceEndYear } }) => {
                      onFilter({ insuranceEndYear });
                    }}
                  >
                    {generateYearOptions(true)}
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>
        </Col>

        <Col sm="12" md="6" lg="3" className="select-wrapper">
          <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
            <Row>
              <Col xs="6">
                <Label>{t('INSURANCES:TITLE_FILTER_END_MONTH')}</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="insuranceEndMonth"
                    name="insuranceEndMonth"
                    disabled={!query.insuranceEndYear}
                    value={query && query.insuranceEndMonth}
                    onChange={({ target: { value: insuranceEndMonth } }) =>
                      onFilter({ insuranceEndMonth })
                    }
                  >
                    {generateMonthOptions()}
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>
        </Col>

        <Col sm="6" md="6" lg="3" xl="3">
          <SearchInput
            query={{ search: query && query.policy_code }}
            onFilter={({ search }) => onFilter({ policy_code: search })}
            label={t('SEARCH:POLICY_CODE')}
          />
        </Col>

        <Col sm="6" md="6" lg="3" xl="3">
          <SearchInput
            query={{ search: query && query.admin_cf }}
            onFilter={({ search }) => onFilter({ admin_cf: search })}
            label={t('SEARCH:REFERENCE_ID')}
          />
        </Col>

        {!['SUPPLIER_INS'].includes(profile.type) && (
          <Col sm="6" md="6" lg="3" xl="3">
            <SearchInput
              query={{ search: query && query.supplier }}
              onFilter={({ search }) => onFilter({ supplier: search })}
              label={t('SEARCH:BY_SUPPLIER')}
            />
          </Col>
        )}

        <Col sm="6" md="6" lg="3" xl="3">
          <SearchInput
            query={{ search: query && query.customer }}
            onFilter={({ search }) => onFilter({ customer: search })}
            label={t('SEARCH:CUSTOMER')}
          />
        </Col>

        <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
          <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
            <Row>
              <Col xs="6">
                <Label>Tipologia cliente</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="customerType"
                    name="customerType"
                    value={customerType}
                    onChange={({ target: { value: customerType } }) =>
                      onFilter({ customerType })
                    }
                  >
                    <option value="" defaultChecked>
                      Tutti
                    </option>
                    <option value="condos">Condomini</option>
                    <option value="customerExtra">Clienti privati</option>
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>
        </Col>

        {!['SUPPLIER_INS'].includes(profile.type) && (
          <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
            <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
              <Row>
                <Col xs="6">
                  <Label>{t('SEARCH:AGENCY_TYPE')}</Label>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <CustomInput
                      type="select"
                      id="agencyType"
                      name="agencyType"
                      value={query.agencyType}
                      onChange={({ target: { value: agencyType } }) =>
                        onFilter({ agencyType })
                      }
                    >
                      <option value="" defaultChecked>
                        Tutti
                      </option>
                      <option value="VITTORIA">VITTORIA</option>
                      <option value="ITAS">ITAS</option>
                      <option value="ITALIANA_ASSICURAZIONI">
                        ITALIANA ASSICURAZIONI
                      </option>
                    </CustomInput>
                  </FormGroup>
                </Col>
              </Row>
            </ContFilterYear>
          </Col>
        )}

        <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
          <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
            <Row>
              <Col xs="6">
                <Label>Rinnovata</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="renovated"
                    name="renovated"
                    value={query.renovated}
                    onChange={({ target: { value: renovated } }) =>
                      onFilter({ renovated })
                    }
                  >
                    <option value="" defaultChecked>
                      Tutti
                    </option>
                    <option value="SI">SI</option>
                    <option value="NO">NO</option>
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>
        </Col>

        <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
          <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
            <Row>
              <Col xs="6">
                <Label>Stato assicurazione</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="active"
                    name="active"
                    value={active}
                    onChange={({ target: { value: active } }) =>
                      onFilter({ active })
                    }
                  >
                    <option value="" defaultChecked>
                      Tutti
                    </option>
                    <option value="active">Attive</option>
                    <option value="terminated">Scadute</option>
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>
        </Col>
      </Row>

      <section className="m-t-20">
        <InsurancesTable
          data={data}
          total={total}
          offset={offset}
          limit={limit}
          onFilter={onFilter}
          profile={profile}
          selectedAll={selectedAll}
          onSelectAll={onSelectAll}
          onSelectChange={onSelectChange}
          onStatusChanged={onStatusChanged}
          selectedInsurances={selectedInsurances}
          setModalState={setModalState}
          searchAdministrators={searchAdministrators}
          searchEstateAgents={searchEstateAgents}
          searchCommercials={searchCommercials}
          fetchAdminCondos={fetchAdminCondos}
          fetchAdminCustomers={fetchAdminCustomers}
          condos={condos}
          customersExtra={customersExtra}
          onInsuranceUpdate={onInsuranceUpdate}
          bottomRow={
            <TotalTr profileType={profile.type} totals={getTotals(data)} />
          }
        />

        <ContPaginationPage>
          <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

          <FormGroup>
            <CustomInput
              type="select"
              className="pagination-select"
              id="perPage"
              name="perPage"
              value={limit}
              onChange={({ target: { value: limit } }) => {
                onFilter({ limit: limit });
              }}
            >
              {generatePaginationOptions()}
            </CustomInput>
          </FormGroup>
        </ContPaginationPage>

        <ModalInvoiceDetailPanoramica
          modalState={modalState}
          setModalState={setModalState}
          onStatusChanged={onStatusChanged}
        />

        <ContFlexRight className="mt-5">
          {selectedInsurances.length > 0 && (
            <ModalConfirm
              onConfirm={() => {
                onInvoice();
              }}
              onOpen={onOpenModal}
              text={
                `Il valore totale delle assicurazioni é: ${totalInsurancesValue} ` +
                '\n' +
                t('CONFIRM_INVOICE')
              }
            >
              <BtnOutlineGreen type="button" className="uppercase">
                FATTURA SELEZIONATI
              </BtnOutlineGreen>
            </ModalConfirm>
          )}
        </ContFlexRight>
      </section>
      <Footer />
    </section>
  );
};

export default InsurancesPresentational;
